import { Directive, EventEmitter, Input } from '@angular/core';
import { ColumnDefinition, CustomCellComponent } from '@vendasta/va-filter2-table';
import { SyncData } from '../../../local-seo';

@Directive()
export class TableColumnDirective implements CustomCellComponent<SyncData> {
  @Input() columnDefinition: ColumnDefinition;
  @Input() element: SyncData;
  @Input() eventEmitter: EventEmitter<ListingsTableRowEvent>;
}

export interface ListingsTableRowEvent {
  element?: SyncData;
  openUpgradeDialog?: boolean;
}
